"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert12To24HourFormat = void 0;
const convert12To24HourFormat = (hours, isAMTimePeriod) => {
    if (hours === 12) {
        return isAMTimePeriod ? 0 : 12;
    }
    return isAMTimePeriod ? hours : hours + 12;
};
exports.convert12To24HourFormat = convert12To24HourFormat;
//# sourceMappingURL=convert12To24HourFormat.js.map